
import { useState } from "react";

import { useSelector } from "react-redux";

import { useNavigate } from "react-router";

import { Grid, Grow, Card, CardActionArea, CardMedia, CardContent, Typography } from "@mui/material"

import { RootState } from "../../store";

import { Layout } from "../../components/Layout"

import { DialogCatalogos } from "../../dialogs/DialogCatalogos"

import { FirstLoginPage } from "../auth/FirstLoginPage";

export const AdministracionPage = () => {  
     
    const navigate = useNavigate();

    const { restablecerContrasena } = useSelector( ( state: RootState ) => state.auth );

    const [open, setOpen] = useState(false);

    return (

        <>   

            {
                restablecerContrasena
                ?
                    <FirstLoginPage />
                : 

                    <Layout breadcrumbs={[ { text: 'Administración' } ]} backgroundPaper={ false }>

                        <Grid container spacing={3}>             

                            <Grid size={{ xs: 12, sm: 6, lg: 4 }}>

                                <Grow
                                    in={true}
                                    style={{ transformOrigin: '0 0 0' }}
                                    {...(true ? { timeout: 1000 } : {})}
                                >

                                    <Card>

                                        <CardActionArea onClick={ () => navigate( '/administracion/usuarios/' ) }>

                                            <CardMedia
                                                component="img"
                                                height="240"
                                                image={ process.env.PUBLIC_URL + '/assets/usuarios.png' }
                                                alt={ "usuarios" }
                                                sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                            />

                                            <CardContent>

                                                <Typography gutterBottom variant="h6" component="div">
                                                    Usuarios
                                                </Typography>   

                                            </CardContent>
                                            
                                        </CardActionArea>                        

                                    </Card>

                                </Grow>

                            </Grid> 

                            <Grid size={{ xs: 12, sm: 6, lg: 4 }}>

                                <Grow
                                    in
                                    style={{ transformOrigin: '0 0 0' }}
                                    {...({ timeout: 1000 })}
                                >

                                    <Card>

                                        <CardActionArea onClick={ () => setOpen( true ) }>

                                            <CardMedia
                                                component="img"
                                                height="240"
                                                image={ process.env.PUBLIC_URL + '/assets/catalogos.png' }
                                                alt={ "catalogos" }
                                                sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                            />

                                            <CardContent>

                                                <Typography gutterBottom variant="h6" component="div">
                                                    Catálogos
                                                </Typography>   

                                            </CardContent>     

                                        </CardActionArea>

                                    </Card>

                                </Grow>

                            </Grid> 
                            
                            <Grid size={{ xs: 12, sm: 6, lg: 4 }}>

                                <Grow
                                    in={true}
                                    style={{ transformOrigin: '0 0 0' }}
                                    {...(true ? { timeout: 1000 } : {})}
                                >

                                    <Card>

                                        <CardActionArea onClick={ () => navigate( '/administracion/apikeys/' ) }>

                                            <CardMedia
                                                component="img"
                                                height="240"
                                                image={ process.env.PUBLIC_URL + '/assets/apikeys.png' }
                                                alt={ "apikeys" }
                                                sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                            />

                                            <CardContent>

                                                <Typography gutterBottom variant="h6" component="div">
                                                    Api Key´s
                                                </Typography>   

                                            </CardContent>
                                            
                                        </CardActionArea>                        

                                    </Card>

                                </Grow>

                            </Grid> 

                            <Grid size={{ xs: 12, sm: 6, lg: 4 }}>

                                <Grow
                                    in={true}
                                    style={{ transformOrigin: '0 0 0' }}
                                    {...(true ? { timeout: 1000 } : {})}
                                >

                                    <Card>

                                        <CardActionArea onClick={ () => navigate( '/administracion/reasignacion-cancelacion/' ) }>

                                            <CardMedia
                                                component="img"
                                                height="240"
                                                image={ process.env.PUBLIC_URL + '/assets/reasignacion-cancelacion.png' }
                                                alt={ "reasignacion" }
                                                sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                            />

                                            <CardContent>

                                                <Typography gutterBottom variant="h6" component="div">
                                                    Reasignación o cancelación de casos
                                                </Typography>   

                                            </CardContent>
                                            
                                        </CardActionArea>                        

                                    </Card>

                                </Grow>

                            </Grid> 

                            <Grid size={{ xs: 12, sm: 6, lg: 4 }}>

                                <Grow
                                    in={true}
                                    style={{ transformOrigin: '0 0 0' }}
                                    {...(true ? { timeout: 1000 } : {})}
                                >

                                    <Card>

                                        <CardActionArea onClick={ () => navigate( '/administracion/administracion-documentos/' ) }>

                                            <CardMedia
                                                component="img"
                                                height="240"
                                                image={ process.env.PUBLIC_URL + '/assets/administracion-documentos.png' }
                                                alt={ "administracion-documentos" }
                                                sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                            />

                                            <CardContent>

                                                <Typography gutterBottom variant="h6" component="div">
                                                    Administración de documentos
                                                </Typography>   

                                            </CardContent>
                                            
                                        </CardActionArea>                        

                                    </Card>

                                </Grow>

                            </Grid> 

                        </Grid>     

                        <DialogCatalogos
                            id="catalogos-menu"
                            keepMounted
                            open={open}
                            onClose={ () => setOpen( false ) }
                        /> 
                        
                    </Layout>  
            }

        </>

    )
}
